<template>
  <div>
    <v-row dense class="mx-1">
      <v-chip close
              class="mt-2"
              v-if="values" @click:close="onClickClose">
        {{values.length}}/{{maxSelect}} selecionado(s)
      </v-chip>
      <v-spacer/>
      <px-search-text label="Busque por uma transportadora" v-model="filters.searchText"
                      style="max-width: 400px"
                      :on-search="onUpdateFilters"/>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    values: Array,
    maxSelect: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      statusOptions: [],
      filters: {
        searchText: null,
      },
    };
  },
  methods: {
    onUpdateFilters() {
      this.$emit('update', this.filters);
    },
    onClickClose() {
      this.$emit('reset');
    },
  },
};
</script>
